// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.three-dots-vertical-package {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 13px;
  cursor: pointer;
  margin: 2px 8px 0 0;
}

.three-dots-vertical-package .dot {
  width: 3px;
  height: 3px;
  background-color: #000;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/containers/packages/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".three-dots-vertical-package {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  height: 13px;\n  cursor: pointer;\n  margin: 2px 8px 0 0;\n}\n\n.three-dots-vertical-package .dot {\n  width: 3px;\n  height: 3px;\n  background-color: #000;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
